import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const _RequestBodySchema = z.object({
    email: z.string().email(),
    expiration_minutes: z.number().optional(),
    login_template_id: z.string().optional(),
    signup_template_id: z.string().optional(),
    locale: z.string().optional(),
    create_user_as_pending: z.boolean().optional(),
    attributes: z
        .object({
        ip_address: z.string().optional(),
        user_agent: z.string().optional(),
    })
        .optional(),
});
const Response = z.object({
    status_code: z.number(),
    method_id: z.string(),
    request_id: z.string(),
    user_id: z.string(),
    user_created: z.boolean(),
});
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/identity/authentication/otps/email/login-or-create"
    : "https://middleware.uat.farther.com/identity/authentication/otps/email/login-or-create";
export const loginOrCreate = async (request) => {
    const res = await axios.post(url(), request, {
        headers: {
            Version: "20240801",
            Authorization: "Bearer none",
            "Content-Type": "application/json",
            "idempotency-key": `${new Date().toISOString()}-${request.email}`,
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[loginOrCreate] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default loginOrCreate;
//# sourceMappingURL=loginOrCreate.js.map